import React from "react";
import IntentHistoryPage from "./views/IntentHistoryPage";
import { IntentHistoryContextProvider } from "./IntentHistoryView";
import IntentHistoryContent from "../../../constants/contentFile.json";

const IntentHistory = () => {
  return (
    <IntentHistoryContextProvider>
      <IntentHistoryPage
        textContents={IntentHistoryContent.intenthistoryPage}
      />
    </IntentHistoryContextProvider>
  );
};

export default IntentHistory;
